/* Klar Vintage theme JS */
document.addEventListener("DOMContentLoaded", function () {
  // Mobile menu
  var btn = document.getElementById("menuBtn");
  var links = document.getElementById("navLinks");
  if (btn && links) {
    btn.addEventListener("click", function () {
      var open = links.classList.toggle("open");
      btn.setAttribute("aria-expanded", open);
    });
  }

  // Scroll reveals
  var reveals = document.querySelectorAll(".reveal");
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    reveals.forEach(function (el) { el.classList.add("in"); });
  } else if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add("in"); });
  }

  // Product page thumbnail swap
  var main = document.getElementById("mainImage");
  document.querySelectorAll("[data-full]").forEach(function (t) {
    t.addEventListener("click", function () { if (main) main.src = t.dataset.full; });
  });
});
